export const ARROW_TOOL_ID = "arrow";

const drawArrow = ({ ctx, from, to, penColor, penSize }) => {
  const headLength = Math.max(10, penSize * 3);
  const angle = Math.atan2(to.y - from.y, to.x - from.x);

  ctx.beginPath();
  ctx.moveTo(from.x, from.y);
  ctx.lineTo(to.x, to.y);
  ctx.stroke();

  ctx.beginPath();
  ctx.moveTo(to.x, to.y);
  ctx.lineTo(
    to.x - headLength * Math.cos(angle - Math.PI / 6),
    to.y - headLength * Math.sin(angle - Math.PI / 6),
  );
  ctx.lineTo(
    to.x - headLength * Math.cos(angle + Math.PI / 6),
    to.y - headLength * Math.sin(angle + Math.PI / 6),
  );
  ctx.lineTo(to.x, to.y);
  ctx.fillStyle = penColor;
  ctx.fill();
};

export const arrowToolConfig = {
  id: ARROW_TOOL_ID,
  usesPreview: true,
  cursor: "crosshair",
  onStart: () => true,
  onMove: ({ ctx, lastPointRef, nextPoint, penColor, penSize }) => {
    drawArrow({
      ctx,
      from: lastPointRef.current,
      to: nextPoint,
      penColor,
      penSize,
    });
  },
  onEnd: ({ ctx, lastPointRef, endPoint, penColor, penSize }) => {
    drawArrow({
      ctx,
      from: lastPointRef.current,
      to: endPoint,
      penColor,
      penSize,
    });
  },
};

const ArrowToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === ARROW_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(ARROW_TOOL_ID)}
      title="Arrow"
      aria-label="Arrow"
    >
      ↗
    </button>
  );
};

export default ArrowToolButton;
